export const COMPETITION_STATUS = [
  { value: "upcoming", label: "即将开始", type: "phase-reg" },
  { value: "registering", label: "报名中", type: "phase-reg" },
  { value: "reviewing", label: "评审中", type: "phase-review" },
  { value: "announcing", label: "公示期", type: "phase-announce" },
  { value: "ended", label: "已颁奖", type: "phase-ended" },
];

export const COMPETITION_STATUS_MAP = {
  registering: "success",
  reviewing: "info",
  announcing: "success",
  ended: "info",
};

// 实名认证状态
export const VERIFY_STATUS = {
  VERIFY_UNSUBMIT: 0,
  VERIFY_SUBMITTING: 1,
  VERIFY_RESOLVE: 2,
  VERIFY_REJECT: 3,
};
